import { useLocalePath } from '#imports';
import {useAlternateHrefStore} from "~/stores/AlternateHrefStore.js";

export default defineNuxtPlugin((nuxtApp) => {
    const localePath = useLocalePath();

    nuxtApp.hook('i18n:localeSwitched', ({ oldLocale, newLocale }) => {
        const route = nuxtApp.$router.currentRoute.value;
        const routeName = route.name.split('_')[0];
        const matchedRouteName = route.matched[0].name;

        if (!matchedRouteName.includes('slug') && !matchedRouteName.includes('code')) {
            return;
        }
        const defaultPageName = routeName.split('-')[0];
        const alternateHref = useAlternateHrefStore().getAlternateHref(newLocale) || localePath({name: defaultPageName});

        if (alternateHref) {
            nuxtApp.$router.push(alternateHref);
        }
    });
});
